export function mastersMobile() {
  const masters = document.querySelectorAll('.masters__item');

  if (masters.length === 0 || window.matchMedia("(min-width: 991.98px)").matches) return;

  masters.forEach(item => {
    item.addEventListener('click', (e) => {
      e.currentTarget.classList.toggle('masters__item--active')

    });
  });
}
